"use strict";
import { StaticJsonRpcProvider } from "@ethersproject/providers";
import { AVERAGE_L1_BLOCK_TIME_MS } from "uniswap/src/features/transactions/swap/hooks/usePollingIntervalByChain";
export default class ConfiguredJsonRpcProvider extends StaticJsonRpcProvider {
  constructor(url, networkish, pollingInterval = AVERAGE_L1_BLOCK_TIME_MS) {
    super(url, networkish);
    this.pollingInterval = pollingInterval;
  }
}
